import React from 'react';

export interface TaskUrlProps {
  contentTaskUrl: string;
  clientUrl: string;
}

export function getTaskUrl(contentTaskUrl: string, clientUrl?: string) {
  // No content task url
  if (!contentTaskUrl) {
    return;
  }
  // Client url not found
  const clientUrlIndex = contentTaskUrl.indexOf(clientUrl);

  if (clientUrlIndex <= -1) return contentTaskUrl;

  const urlIndex = clientUrlIndex + (clientUrl?.length ?? 0);
  const urlSnippet = contentTaskUrl?.substring(Math.max(urlIndex, 0));
  const start = urlSnippet.startsWith('/') || urlSnippet.startsWith('http') ? '' : '/';
  return start + urlSnippet;
}

export function getLongUrl(shortUrl: string, clientUrl: string) {
  if (!clientUrl) {
    return;
  }

  const endsWithDash = clientUrl?.endsWith('/');
  const clientUrlSnippet = endsWithDash ? clientUrl.substring(0, clientUrl.length - 1) : clientUrl;

  return clientUrlSnippet + shortUrl;
}

export const TaskUrl: React.FC<TaskUrlProps> = React.memo(({ contentTaskUrl, clientUrl }) => {
  return <>{getTaskUrl(contentTaskUrl, clientUrl)} </>;
});

export default TaskUrl;
